<template>
    <div >
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="ReportTitle"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
           ref="printwristbandReport"
          :ReportName="'LabelsReport'"
          :ReportTitle="ReportTitle"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import StorageService from '@/services/storage.service'

    export default Vue.extend({
        name: "PrintWristbandRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          PatientCode: String,
          ReportTitle: String,
   
        },
        data() {
            return {
              token: `Bearer ${StorageService.getOnlyToken()}`,
              isReportVisible: false,
            }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.closeWindow()
            },

            onClickClose() {
              this.closeWindow()
              this.isParamVisible = false;
            },

            onShowReport() {
              this.reportParams = []

              this.reportParams.push({ paramName: 'codeList', paramValue: this.PatientCode})
              this.reportParams.push({ paramName: 'code', paramValue: 'WB'})
              
              this.isReportVisible = true

              this.$refs.printwristbandReport.buildDocument(this.reportParams)
            }
        },
        
        mounted () {          
          this.onShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
